import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import RankTab from "../../../components/Rank/RankTab";
import { get } from "../../../utils/request";
import "./style.css";
import "../../../index.css";
class SchoolRank extends Component {
  componentDidMount = () => {
    document.title = "浙考之家-精选排名-学科/大学排名";
  };
  componentWillMount() {
    this.requestShareConfig();
  }
  render() {
    return (
      <div className="schoolRank_box">
        <RankTab subjectActive={false} schoolActive={true}></RankTab>
        <NavLink to="/rank/school/intro/VmFy">
          <img alt="" src={require("../../../images/rank/01.jpg")}></img>
        </NavLink>
        <NavLink to="/rank/school/intro/LDU7">
          <img
            className="major_top_7_5"
            alt=""
            src={require("../../../images/rank/02.jpg")}
          ></img>
        </NavLink>
        <NavLink to="/rank/school/nostar/intro/WqsL">
          <img
            className="major_top_7_5"
            alt=""
            src={require("../../../images/rank/03.jpg")}
          ></img>
        </NavLink>

        <div style={{ height: 47 }}></div>
      </div>
    );
  }
  /**
   * 请求分享的配置
   */
  requestShareConfig = () => {
    const url = window.location.href;
    get("/api/share/config?url=" + url).then((res) => {
      if (res.status === "success") {
        let signature = res.data.signature;
        let timestamp = res.data.timestamp;
        let noncestr = res.data.nonceStr;
        let appid = res.data.appId;
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有public/v1的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appid, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: noncestr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"], // 必填，需要使用的JS接口列表
        });

        window.wx.ready(function () {
          //分享给朋友
          window.wx.onMenuShareAppMessage({
            title: "浙考之家-精选排名-学科/大学排名", // 分享标题
            desc: "一站式升学、就业规划，找浙考之家", // 分享描述
            link: url, // 分享.链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标s
            type: "link", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户确认分享后执行的回调函数
              //                 alert("OK");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              //                 alert("fail");
            },
          });
          //分享给朋友圈
          window.wx.onMenuShareTimeline({
            title: "浙考之家-精选排名-学科/大学排名", // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
          });
        });
      }
    });
  };
}

export default SchoolRank;



// WEBPACK FOOTER //
// ./src/containers/Rank/SchoolRank/index.js